/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionTier } from './SubscriptionTier';
import {
    SubscriptionTierFromJSON,
    SubscriptionTierFromJSONTyped,
    SubscriptionTierToJSON,
    SubscriptionTierToJSONTyped,
} from './SubscriptionTier';

/**
 * 
 * @export
 * @interface UserCapabilitiesResponse
 */
export interface UserCapabilitiesResponse {
    /**
     * 
     * @type {SubscriptionTier}
     * @memberof UserCapabilitiesResponse
     */
    effective_tier: SubscriptionTier;
    /**
     * 
     * @type {boolean}
     * @memberof UserCapabilitiesResponse
     */
    can_send_emergency: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserCapabilitiesResponse
     */
    can_view_emergency_map: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserCapabilitiesResponse
     */
    can_view_map: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserCapabilitiesResponse
     */
    can_be_assigned_to_pvd_config: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserCapabilitiesResponse
     */
    can_be_assigned_to_respond_config: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserCapabilitiesResponse
     */
    org_has_ops_inventory: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserCapabilitiesResponse
     */
    org_has_respond_inventory: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserCapabilitiesResponse
     */
    org_has_any_paid_inventory: boolean;
}



/**
 * Check if a given object implements the UserCapabilitiesResponse interface.
 */
export function instanceOfUserCapabilitiesResponse(value: object): value is UserCapabilitiesResponse {
    if (!('effective_tier' in value) || value['effective_tier'] === undefined) return false;
    if (!('can_send_emergency' in value) || value['can_send_emergency'] === undefined) return false;
    if (!('can_view_emergency_map' in value) || value['can_view_emergency_map'] === undefined) return false;
    if (!('can_view_map' in value) || value['can_view_map'] === undefined) return false;
    if (!('can_be_assigned_to_pvd_config' in value) || value['can_be_assigned_to_pvd_config'] === undefined) return false;
    if (!('can_be_assigned_to_respond_config' in value) || value['can_be_assigned_to_respond_config'] === undefined) return false;
    if (!('org_has_ops_inventory' in value) || value['org_has_ops_inventory'] === undefined) return false;
    if (!('org_has_respond_inventory' in value) || value['org_has_respond_inventory'] === undefined) return false;
    if (!('org_has_any_paid_inventory' in value) || value['org_has_any_paid_inventory'] === undefined) return false;
    return true;
}

export function UserCapabilitiesResponseFromJSON(json: any): UserCapabilitiesResponse {
    return UserCapabilitiesResponseFromJSONTyped(json, false);
}

export function UserCapabilitiesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserCapabilitiesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'effective_tier': SubscriptionTierFromJSON(json['effective_tier']),
        'can_send_emergency': json['can_send_emergency'],
        'can_view_emergency_map': json['can_view_emergency_map'],
        'can_view_map': json['can_view_map'],
        'can_be_assigned_to_pvd_config': json['can_be_assigned_to_pvd_config'],
        'can_be_assigned_to_respond_config': json['can_be_assigned_to_respond_config'],
        'org_has_ops_inventory': json['org_has_ops_inventory'],
        'org_has_respond_inventory': json['org_has_respond_inventory'],
        'org_has_any_paid_inventory': json['org_has_any_paid_inventory'],
    };
}

export function UserCapabilitiesResponseToJSON(json: any): UserCapabilitiesResponse {
    return UserCapabilitiesResponseToJSONTyped(json, false);
}

export function UserCapabilitiesResponseToJSONTyped(value?: UserCapabilitiesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'effective_tier': SubscriptionTierToJSON(value['effective_tier']),
        'can_send_emergency': value['can_send_emergency'],
        'can_view_emergency_map': value['can_view_emergency_map'],
        'can_view_map': value['can_view_map'],
        'can_be_assigned_to_pvd_config': value['can_be_assigned_to_pvd_config'],
        'can_be_assigned_to_respond_config': value['can_be_assigned_to_respond_config'],
        'org_has_ops_inventory': value['org_has_ops_inventory'],
        'org_has_respond_inventory': value['org_has_respond_inventory'],
        'org_has_any_paid_inventory': value['org_has_any_paid_inventory'],
    };
}

